import { render, staticRenderFns } from "./CourseActionsSheet.vue?vue&type=template&id=007ec72e"
import script from "./CourseActionsSheet.vue?vue&type=script&lang=js"
export * from "./CourseActionsSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports